import StatusBadge from "./StatusBadge";
import {
  STAGE_META,
  StageConfig,
  StageKey,
} from "../../../utils/integrationConfigData";
import { toTitleCase } from "../../../utils/Utils";

interface StageSummaryCardProps {
  stageKey: StageKey;
  stage?: StageConfig;
  onClick?: () => void;
}

const StageSummaryCard = ({ stageKey, stage, onClick }: StageSummaryCardProps) => {
  const meta = STAGE_META[stageKey];
  const detail =
    stage?.endpoint ||
    (stage?.status ? ` ${toTitleCase(stage.status)}` : "Not configured yet");
  const status = stage?.status || "Not Set";
  const className = `ic-stage-tile${onClick ? " ic-stage-tile--clickable" : ""}`;

  const content = (
    <>
      <div className="ic-stage-tile-top">
        <span className="ic-stage-tile-icon ic-stats-icon">
          <i className={meta.icon} aria-hidden="true"></i>
        </span>
        <div className="ic-stage-tile-heading">
          <h3 className="ic-stage-tile-title">{meta.label}</h3>
          <StatusBadge status={status} />
        </div>
      </div>
    </>
  );

  if (onClick) {
    return (
      <button
        type="button"
        className={className}
        onClick={onClick}
        aria-label={`Open ${meta.label} configuration`}
      >
        {content}
      </button>
    );
  }

  return <article className={className}>{content}</article>;
};

export default StageSummaryCard;
